<template>
  <div class="w-full">
    <div class="form-control w-full" :class="id !== '' ? 'fc-'+id:'fc-'+randomId">
      <label
:for="id !== '' ? id : randomId"
        :class="[{
          'text-red-500':error || _error
          }]"
        class="absolute z-10 text-sm cursor-text transition bg-white p-1 translate-x-3 translate-y-1 text-xs text-[#333333]">
        {{label}}
      </label>
      <select
:id="id !== '' ? id : randomId" v-model="inputValue" :disabled="disabled"
        :class="cssClass" class="select select-bordered w-full bg-white w-full disabled:bg-white h-[58px] pt-3" @focus="isFocused = true"
        @blur="checkValue()"
        @change="checkValue()">
        <option :value="null" disabled selected>Please Select {{ label }}</option>
        <option v-for="o in options" :value="o.value">{{ o.label }}</option>
      </select>
    </div>
    <div v-if="error || _error" class="text-xs text-red-500 mt-1">
      {{ _error ? _error : error }}
    </div>
    <div v-if="(!error && !_error) && helpText" class="text-xs text-ellie-yellow mt-1">
      {{ helpText }}
    </div>
  </div>
</template>

<script setup>
import MakeId from '@/includes/MakeId';
const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  value: {
    type: String,
    default: null,
  },
  options: {
    type: Array,
    default: [{
      label: 'Pick One',
      value: null,
    }],
  },
  id: {
    type: String,
    default: '',
  },
  error: {
    type: String,
    default: null,
  },
  required: {
    type: Boolean,
    default: false,
  },
  isSubmitting: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  cssClass: {
    type: String,
    default: '',
  },
  helpText: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['onChange', 'onError']);
const randomId = 'input-' + MakeId(4);
const initialValue = props.value !== undefined ? props.value : null;
const computedValue = ref(initialValue);
const inputValue = computed({
  get: () => {
    return computedValue.value;
  },
  set: (val) => {
    computedValue.value = val;
    return val;
  },
});
const isFocused = ref(false);
const _error = ref(null);

const checkValue = () => {
  if (inputValue.value === '') {
    isFocused.value = false;
  } else {
    isFocused.value = true;
  }

  if (props.required) validateRequired();
  if (props.error || _error.value) {
    emit('onError', props.error ? props.error : _error.value);
    return;
  }
  emit('onChange', inputValue.value);
};

const validateRequired = async () => {
  if (inputValue.value !== null && inputValue.value.trim() === '') {
    _error.value = props.label + ' is required';
    emit('onError', props.error ? props.error : _error.value);
    return false;
  } else if (inputValue.value == null) {
    _error.value = props.label + ' is required';
    emit('onError', props.error ? props.error : _error.value);
    return false;
  }
  _error.value = null;
  emit('onChange', inputValue.value);
  return true;
};

watch(() => inputValue.value, (val) => {
  if (val !== '') {
    isFocused.value = true;
  }
});

watch(() => props.isSubmitting, (val) => {
  if (val === true && props.required) {
    validateRequired();
    if (props.error || _error.value) {
      emit('onError', props.error ? props.error : _error.value);
    }
  }
});

watch(() => props.value, (newValue, oldValue) => {
  if (newValue !== oldValue) {
    inputValue.value = newValue;
  }
});
</script>

<style lang="scss" scoped>

</style>
